import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ROLE_LABEL, USER_ROLE } from './constants';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { RoleDetailModel } from '../models/role-detail.model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly isBrowser: boolean;
  private readonly loggedIn: BehaviorSubject<boolean>;
  isLoggedIn: Observable<boolean>;
  public isLoggenUser = false;
  tenantId: string = '';
  email: string = '';
  userId: string = '';
  token: string = '';
  userRole: string = '';
  username: string = '';
  _userRoles!: RoleDetailModel[];
  userRoleLable: string = '';
  isBuyerRole: boolean = false;
  authority: string[] = [];
  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: any,
    private readonly router: Router
  ) {
    this.isLoggenUser = this.getIsLoggedIn();
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.updateUserDetails();
    const initialLoggedIn = this.getStoredLoggedIn();
    this.loggedIn = new BehaviorSubject<boolean>(initialLoggedIn);
    this.isLoggedIn = this.loggedIn.asObservable();
  }

  getTenantId() {
    return this.tenantId;
  }

  getEmail() {
    return this.email;
  }

  getUserId() {
    return this.userId;
  }

  getToken() {
    return this.token;
  }

  getUsername() {
    return this.username;
  }

  getIsLoggedIn(): boolean {
    return this.getStoredLoggedIn();
  }
  isBuyer(): boolean {
    const role = Number(this.userRole);
    return role === USER_ROLE.BUYER;
  }

  isBuyOrAdminBuyer(): boolean {
    const role = Number(this.userRole);
    return role === USER_ROLE.BUYER || role === USER_ROLE.ADMIN_BUYER || role === USER_ROLE.ADMIN;
  }

  isSupplier(): boolean {
    const role = Number(this.userRole);
    return role === USER_ROLE.SUPPLIER;
  }

  isAdmin(): boolean {
    const role = Number(this.userRole);
    return role === USER_ROLE.ADMIN_BUYER || role === USER_ROLE.ADMIN_SUPPLIER || role === USER_ROLE.ADMIN;
  }

  isAdminBuyer(): boolean {
    return Number(this.userRole) === USER_ROLE.ADMIN_BUYER || Number(this.userRole) === USER_ROLE.ADMIN;
  }

  isAdminSupplier(): boolean {
    return Number(this.userRole) === USER_ROLE.ADMIN_SUPPLIER;
  }

  updateUserDetails() {
    if (this.isBrowser) {
      this.tenantId = localStorage.getItem('tenantId') ?? '';
      this.email = localStorage.getItem('email') ?? '';
      this.userId = localStorage.getItem('userId') ?? '';
      this.username = localStorage.getItem('username') ?? '';
      this.token = localStorage.getItem('token') ?? '';
      this.userRole = localStorage.getItem('userRole') ?? '';
      this.isBuyerRole = this.isBuyer();
      this.userRoleLable = localStorage.getItem('loggedInLable') ?? '';
      try {
        const rawAuthorities = localStorage.getItem('authorities');
        const parsed = JSON.parse(rawAuthorities ?? '[]');
        this.authority = Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        this.authority = [];
      }
      try {
        this._userRoles = JSON.parse(localStorage.getItem('roles') ?? '') ?? [];
      } catch {
        this._userRoles = [];
      }
      this.isLoggenUser = this.getIsLoggedIn();
    }
  }

  get userRoles() {
    return this._userRoles;
  }
  logout() {
    if (this.isBrowser) localStorage.clear();
    this.clearAllUserData();
    this.router.navigate(['login']);
    if (this.isBrowser) {
      localStorage.setItem('isLoggedIn', '0');
    }
    this.setLoggedIn(false);
  }

  setLoggedIn(value: boolean): void {
    this.loggedIn.next(value);
  }

  private getStoredLoggedIn(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      try {
        const storedLoggedIn = this.platformId
          ? localStorage.getItem('isLoggedIn')
          : '0';
        return storedLoggedIn === '1';
      } catch (e) {
        console.error('Error accessing localStorage', e);
      }
    }
    return false;
  }

  isBuyerOrAdmin() {
    return this.isBuyer() || this.isAdmin();
  }

  assignRoleLabel() {
    if (this.isBuyer()) this.userRole = ROLE_LABEL.BUYER;
    else if (this.isSupplier()) this.userRole = ROLE_LABEL.SUPPLIER;
    else if (this.isAdminSupplier()) this.userRole = ROLE_LABEL.ADMIN_SUPPLIER;
    else if (this.isAdminBuyer()) {
      this.userRole = ROLE_LABEL.ADMIN_BUYER;
    } else if (this.isAdmin()) {
      this.userRole = ROLE_LABEL.ADMIN;
    }
  }

  clearAllUserData() {
    this.tenantId = '';
    this.email = '';
    this.userId = '';
    this.username = '';
    this.token = '';
    this.userRole = '';
    this.isBuyerRole = false;
    this.userRoleLable = '';
    this._userRoles = [];
    this.isLoggenUser = false;
  }

  get authorities(): string[] {
    return this.authority;
  }

  get getEntityName():string{
    return localStorage.getItem('entityName')||'NA';
  }

  get getCompanyName(): string {
    return localStorage.getItem('tenantName') || this.getEntityName;
  }

  get getContactNo():string{
    // return JSON.parse(localStorage.getItem('contactNo')||'NA').toString();
    const stored = localStorage.getItem('contactNo');
    return stored && stored !== 'undefined' ? JSON.parse(stored).toString() : 'NA';
  }

  isEmailContainMoglix():boolean{
    return this.getEmail()?.toLocaleLowerCase()?.includes('moglix.com')
  }
  
}
